import React from "react";
import { Link } from "react-router-dom";
import "./BottomBar.css";

function BottomBar() {
  return (
    <div className="bottom_bar">
      <div className="bottomTop">Tunisia</div>
      <div className="bottomBottom">
        <div className="bottomBottom_Left">
          <Link to="">About</Link>
          <Link to="">Advertising</Link>
          <Link to="">Business</Link>
          <Link to="">How Search works</Link>
        </div>
        <div className="bottomBottom_Right">
          <Link to="">Privacy</Link>
          <Link to="">Terms</Link>
          <Link to="">Settings</Link>
        </div>
      </div>
    </div>
  );
}

export default BottomBar;
